import Button from '@eduzz/houston-ui/Button';
import Typography from '@eduzz/houston-ui/Typography';
import { Grid, Icon } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

import { Export } from './Export';
import { useStyles } from './styles';

export const Details = () => {
  const classes = useStyles();

  const openModalTrackingCodes = useCallback(() => ordersService.openModalTrackingCodes(), []);
  const [totalItems] = useObservable(() => ordersService.getTotalItems(), []);
  const [loading] = useObservable(() => ordersService.isLoading(), []);

  if (loading) return null;

  return (
    <>
      <div className={classes.root} id='orders-details'>
        <Grid container direction='row' justify='space-between' alignItems='center' spacing={2}>
          <Grid item>
            <Typography id='orders-result-button-label' weight='semibold'>
              {totalItems || 0} entregas
            </Typography>
          </Grid>

          <Grid item className={classes.gridItemRight}>
            <PermissionHide action='myeduzz:minhas-entregas:editar'>
              <Button
                id='batch-screening'
                variant='text'
                disabled={!totalItems}
                onClick={openModalTrackingCodes}
                startIcon={<Icon>double_arrow</Icon>}
              >
                Rastreio em Lote
              </Button>
            </PermissionHide>
            <PermissionHide action='myeduzz:minhas-entregas:exportar'>
              <Export />
            </PermissionHide>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
